<template>
  <div class="signup-complete-pane">
    <signup-header-section :steps="0" :pageTitle="$tc('SignupPage.Steps.complete')" />
    <div class="signup-complete-pane__main">
      <signup-complete-section
        :isCouponUsed="isCouponUsed"
        :attentionMessage="attentionMessage"
        :paymentSchedule="paymentSchedule"
        @onMoveToLogin="onMoveToLogin"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, PropType } from '@vue/composition-api'
import SignupHeaderSection from '@/components/SignupPage/common/SignupHeaderSection.vue'
import SignupCompleteSection from '@/components/SignupPage/SignupCompletePane/SignupCompleteSection.vue'
import { AttentionMessageData } from '@/components/pc/MyPage/common/AttentionMessageSection.vue'
import { PaymentScheduleData } from '@/components/pc/MyPage/common/PaymentScheduleSection.vue'

/**
 * 新規会員登録: 会員登録完了ペインのコンポーネント
 */
export default defineComponent({
  name: 'SignupCompletePane',
  components: {
    SignupHeaderSection,
    SignupCompleteSection,
  },
  props: {
    /**
     * クーポンを使用してるか
     */
    isCouponUsed: {
      type: Boolean,
      default: false,
    },
    /**
     * 注意メッセージ
     */
    attentionMessage: {
      type: Object as PropType<AttentionMessageData>,
      default: null,
    },
    /**
     * 請求予定情報
     */
    paymentSchedule: {
      type: Array as PropType<PaymentScheduleData[]>,
      default: null,
    },
  },
  setup(_, { emit }) {
    /**
     * ログイン画面に遷移
     */
    const onMoveToLogin = () => {
      emit('onMoveToLogin')
    }

    /**
     * 新規会員登録が完了した場合、契約情報更新漏れを防ぐため、完了画面を離れた時にリロードしてログアウト状態にする
     */
    onBeforeUnmount(() => {
      window.location.reload()
    })

    return {
      onMoveToLogin,
    }
  },
})
</script>

<style lang="scss" scoped>
.signup-complete-pane {
  width: 100%;
  min-height: calc(100vh - 48px);
  margin: 0 auto;
  text-align: center;
  background: $gray1;

  &__main {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }

  &__action-buttons {
    bottom: 0;
  }
}
</style>
